import { axiosHelper } from 'Services/AxiosHelper';
import { OnGetCommissionByBinNumberModel } from 'Models';
import { onGetCommissionByBinNumberReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnGetCommissionByBinNumber';

const onGetCommissionByBinNumber = async (
  params: onGetCommissionByBinNumberReqBodyData
): Promise<OnGetCommissionByBinNumberModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onGetCommissionByBinNumber;
